import React from "react";
import { Avatar } from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";

class AvailableConnectorRegular extends React.Component {
  render() {
    return (
      <React.Fragment>
        {/* TODO - on hover image, show image upload https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_image_overlay_icon */}
        <Avatar alt="Remy Sharp" src={this.props.getConnectorImage()} className={this.props.classes.bigAvatar} />
        <DialogContentText className={this.props.classes.desc}>{this.props.connection.longDesc}</DialogContentText>
      </React.Fragment>
    );
  }
}

export default AvailableConnectorRegular;
